import { B2BSubnav } from '@zillow/zrs-cms';
import React from 'react';

interface MenuItem {
    id: string | number;
    title: { rendered: string; raw?: string };
    url: string;
    parent: string | number;
}

interface ParsedMenuItem {
    id: number;
    title: string;
    url: string;
    parent: number;
    children: ParsedMenuItem[];
}

interface LearningCenterSubnavProps {
    menu: {
        items: MenuItem[];
    };
}

const LearningCenterSubnav: React.FC<LearningCenterSubnavProps> = ({
    menu,
}) => {
    // Parse menu items recursively
    function parseMenu(items: MenuItem[], root = 0): ParsedMenuItem[] {
        return items
            .filter((item) => parseInt(item.parent.toString()) === root)
            .map((menuItem) => {
                return {
                    id: parseInt(menuItem.id.toString()),
                    title:
                        typeof menuItem.title === 'string'
                            ? menuItem.title
                            : menuItem.title?.rendered ||
                              menuItem.title?.raw ||
                              '',
                    url: menuItem.url,
                    parent: parseInt(menuItem.parent.toString()),
                    children: parseMenu(items, Number(menuItem.id)),
                };
            });
    }

    // Transform menu data to B2BSubnav format (only top-level items)
    const subnavItems = parseMenu(menu?.items || []);

    return (
        <B2BSubnav
            primaryItem={{
                id: 0,
                title: 'Learning Center',
                url: '/learn/',
                parent: 0,
            }}
            items={subnavItems}
            searchPrefix="/learn/search/"
            searchPlaceholder="Search Learning Center"
        />
    );
};

export default LearningCenterSubnav;
